import React from "react";

const TermsConditions = ({ onBack }) => {
  return (
    <div className="min-h-screen">

      <div className="w-full flex items-center" style={{
            background: "linear-gradient(to bottom, rgba(225, 225, 225, 1) 0%, rgba(225, 225, 225, 0) 100%)",
            padding: "35px 21px 26px"
      }}>
        <button
          onClick={onBack}
          className=" absolute top-[34px] bg-white rounded-full p-1 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-400"
            fill="none"
            viewBox="0 0 26 26"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        {/* Title */}
        <h1 className="text-[20px] leading-[20px] font-normal font-young-serif text-center mx-auto">
          Terms & Conditions
        </h1>
      </div>
      <div className="mx-7 border-t border-[#EEEEEE]" />

      <div className="text-[#000000] leading-[20px] text-[16px] font-normal font-space-grotesk p-6">
        <section>
          <p>
            These terms set out our rules and policies for using our website.
            By using our website, you confirm that you accept these terms of use and that you agree to comply with them.
            If you do not agree to these terms, you must not use our website.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsConditions;